



















import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/africadogs/PopupTemplate.vue'
import QuizAfricaDogs from '@/views/organisms/QuizAfricaDogs.vue'

export default
  components: {
    PopupTemplate
    QuizAfricaDogs
  }

  data: () ->
    baseColor: '#ECC236'
    point: 0
    mode: 0
    quizResult: 0
    quizData:
      hukidashi: [
        'デアバロさんがわずか3ヶ月でアトリエを'
        'オープンするきっかけとなった商品は'
        '次のうちのどれでしょうか？'
      ]
      quiz: [
        'ブルゾン'
        'オーダースーツ'
        '着物の帯'
      ]
      success_message: [
        'デアバロさんが僕たちと最初に手掛けたのはブルゾンです。そのブルゾンに、ぼくたちは「miwodeka ミウォーデカ」と名づけました。ミウォーデカはトーゴのエウェ民族のことばで「2つは1つ」という意味です。'
      ]
      answer: 1

  methods: {
    closePopup: () ->
      m = @mode
      if m == 0
        m = 2
      @$emit('closePopup', m)
    success: () ->
      @mode = 3
      @quizResult = 2
      @baseColor = '#F699AB'
      api = new ApiClient()
      param =
        'point_code': 'p3-12'
      data = await api.post('/member/point/save', true, param)
      @point = data.point
      if @point > 0
        @$emit('addPoint', @point)
      @$emit('success')
    miss: () ->
      @baseColor = '#7BCAD8'
      @mode = 2
      @quizResult = 1
  }
